<template>
  <div ref="target">
    <section class="rc-carousel-hooper">
      <div :class="fluid ? 'container-fluid' : 'container'">
        <div class="rc-carousel-hooper--header">
          <div
            class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave bg-secondary me-2"
            style="width: 15%"
          />
          <div
            class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave bg-secondary me-2"
            style="width: 5%"
          />
        </div>
      </div>
      <div class="rc-carousel-hooper--body">
        <div class="rc-carousel-hooper--controls">
          <rc-btn
            variant="link"
            class="rc-btn-icon"
            tabindex="-1"
            aria-hidden="true"
            disabled="disabled"
          >
            <RcIcon
              name="chevronLeft"
              scale="1"
            />
          </rc-btn>
          <rc-btn
            variant="link"
            class="rc-btn-icon"
            tabindex="-1"
            aria-hidden="true"
          >
            <RcIcon
              name="chevronRight"
              scale="1"
            />
          </rc-btn>
        </div>
        <div class="rc-carousel-hooper--slides">
          <div class="row g-0">
            <Hooper
              ref="carousel"
              :settings="mergedSettings"
            >
              <Slide
                v-for="(x, i) in count"
                :key="i"
              >
                <div>
                  <RcGridSkeletonUnit class="col" />
                </div>
              </Slide>
            </Hooper>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import RcGridSkeletonUnit from '@/libvue/apps/catalog/items/GridSkeletonUnit.vue';
import { Hooper, Slide } from 'hooper-vue3';
import RcIcon from '@/libvue/components/icons/Base.vue';
import 'hooper-vue3/dist/hooper.css';

export default {
  name: 'RcCarouselSkeleton',
  components: {
    RcIcon,
    RcGridSkeletonUnit,
    Hooper,
    Slide
  },
  props: {
    items: {
      type: Object,
      default: () => {}
    },
    count: {
      type: Number,
      required: false,
      default: 8
    },
    settings: {
      type: Object,
      default: () => ({
        rtl: false,
        infiniteScroll: false,
        wheelControl: false,
        trimWhiteSpace: true,
        breakpoints: {
          1400: {
            itemsToShow: 5.07
          },
          1200: {
            itemsToShow: 4.57
          },
          992: {
            itemsToShow: 3.7
          },
          768: {
            itemsToShow: 3.5
          },
          576: {
            itemsToShow: 2.25
          },
          0: {
            itemsToShow: 1.2
          }
        }
      })
    },

    fluid: {
      type: Boolean,
      default: false
    }
  },
  emits: ['visible'],
  setup() {
    const target = ref(null);
    const targetIsVisible = ref(false);

    useIntersectionObserver(target, ([{ isIntersecting }]) => {
      targetIsVisible.value = isIntersecting;
    });

    return {
      target,
      targetIsVisible
    };
  },
  data() {
    return {
      hooperSettings: {
        rtl: false,
        infiniteScroll: false,
        wheelControl: false,
        trimWhiteSpace: true,
        breakpoints: {
          1400: {
            itemsToShow: 5.07
          },
          1200: {
            itemsToShow: 4.57
          },
          992: {
            itemsToShow: 3.7
          },
          768: {
            itemsToShow: 3.5
          },
          576: {
            itemsToShow: 2.25
          },
          0: {
            itemsToShow: 1.2
          }
        }
      }
    };
  },

  computed: {
    visSettings() {
      return {
        callback: this.visibilityChanged,
        once: true,
        throttle: 150
      };
    },
    mergedSettings() {
      return {
        ...this.hooperSettings,
        ...this.settings
      };
    }
  },
  watch: {
    targetIsVisible(isVisble) {
      this.$emit('visible', isVisble);
    }
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.$emit('visible', isVisible, entry);
    }
  }
};
</script>
